// circular_progress_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["progressCircle", "text"]

  static values = {
    progress: { type: Number, default: 0 },
    circumference: Number
  }

  isFirstUpdate = true

  connect() {
    this.updateProgress()
  }

  progressValueChanged() {
    this.updateProgress()
  }

  // Méthode publique pour être appelée par le parent
  updateProgressValue(value) {
    this.progressValue = value
  }

  updateProgress() {

    if (this.isFirstUpdate
    ) {
      this.element.classList.remove("hidden")
      this.isFirstUpdate = false
    }

    const progress = this.progressValue
    const circumference = this.circumferenceValue
    const offset = circumference - (progress / 100) * circumference

    // Mise à jour uniquement des attributs dynamiques
    this.progressCircleTarget.setAttribute("stroke-dashoffset", offset)
    this.textTarget.textContent = `${Math.round(progress)}%`
  }
}
